/*
================================================================================================
ReCharge Widget Customizer for Shopify Dawn Theme
================================================================================================
*/

document.addEventListener('DOMContentLoaded', () => {
  // --- CONFIGURATION ---
  // Add the exact text of the subscription options you want to KEEP VISIBLE.
  // The "One Time Purchase" option is handled automatically.
  // Example: ['Subscribe Monthly', 'Subscribe Quarterly']
  const visibleSubscriptionOptions = ['Subscribe Monthly', 'Subscribe Quarterly'];
  // --- END CONFIGURATION ---

  const customizeRechargeWidget = (widgetNode) => {
    // Find all radio button options within the widget
    const allOptions = widgetNode.querySelectorAll('.rc-radio');

    if (allOptions.length <= visibleSubscriptionOptions.length + 1) {
      // Not enough options to group, so do nothing.
      return;
    }

    // Check if the customization has already been applied
    if (widgetNode.querySelector('.other-options-container')) {
      return;
    }

    const oneTimePurchase = widgetNode.querySelector('.rc-radio__input[data-onetime-purchase]');
    const oneTimePurchaseGroup = oneTimePurchase ? oneTimePurchase.closest('.rc-radio') : null;

    const optionsToKeep = [oneTimePurchaseGroup];
    const optionsToHide = [];

    // Separate the options to keep visible and the ones to hide
    allOptions.forEach((option) => {
      if (option === oneTimePurchaseGroup) return; // Already handled

      const label = option.querySelector('.rc-radio__label');
      if (label && visibleSubscriptionOptions.some((visibleText) => label.textContent.includes(visibleText))) {
        optionsToKeep.push(option);
      } else {
        optionsToHide.push(option);
      }
    });

    if (optionsToHide.length === 0) {
      // No options to hide, so do nothing.
      return;
    }

    // Create the container for the hidden "Other" options
    const otherOptionsContainer = document.createElement('div');
    otherOptionsContainer.className = 'other-options-container';
    otherOptionsContainer.style.display = 'none'; // Hide it by default
    otherOptionsContainer.style.paddingLeft = '20px'; // Indent the hidden options

    optionsToHide.forEach((option) => {
      otherOptionsContainer.appendChild(option);
    });

    // Create the "Other Subscription Options" radio button
    const otherOptionToggle = document.createElement('div');
    otherOptionToggle.className = 'rc-radio other-options-toggle';
    otherOptionToggle.innerHTML = `
      <input type="radio" name="purchase_option_group" id="other-options-radio" class="rc-radio__input">
      <label for="other-options-radio" class="rc-radio__label">Other Subscription Options</label>
    `;

    // Insert the toggle and the container into the widget
    const lastVisibleOption = optionsToKeep[optionsToKeep.length - 1];
    if (lastVisibleOption && lastVisibleOption.parentNode) {
      lastVisibleOption.after(otherOptionToggle);
      otherOptionToggle.after(otherOptionsContainer);
    }

    // --- Event Listeners ---

    // When "Other..." is clicked, show the hidden options and select the first one
    otherOptionToggle.addEventListener('click', () => {
      otherOptionsContainer.style.display = 'block';
      document.getElementById('other-options-radio').checked = true;
      // Automatically check the first actual subscription option inside
      const firstHiddenInput = optionsToHide[0]?.querySelector('input[type="radio"]');
      if (firstHiddenInput) {
        firstHiddenInput.checked = true;
        // Dispatch a change event to let ReCharge know
        firstHiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // When a main visible option is clicked, hide the "Other" options
    optionsToKeep.forEach((option) => {
      option?.addEventListener('click', () => {
        otherOptionsContainer.style.display = 'none';
        document.getElementById('other-options-radio').checked = false;
      });
    });

    // When an option inside the "Other" container is clicked, keep the "Other" radio selected
    optionsToHide.forEach((option) => {
      option.addEventListener('click', () => {
        document.getElementById('other-options-radio').checked = true;
      });
    });
  };

  // Use MutationObserver to wait for the ReCharge widget to load
  const observer = new MutationObserver((mutations, obs) => {
    const rechargeWidget = document.querySelector('.rc-widget-injection-parent');
    if (rechargeWidget) {
      // Run the customization function
      customizeRechargeWidget(rechargeWidget);
      // We can disconnect the observer if the widget doesn't re-render on variant change.
      // However, it's safer to leave it active to handle potential re-renders.
      // obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
